import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { IconArrowInbox } from 'central-icons/IconArrowInbox';
import Iframe from 'react-iframe';

import type { UploadFileResult } from '@revelio/data-access';

export type PptPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
} & Pick<UploadFileResult, 'previewUrl' | 'downloadUrl' | 'editUrl'>;

export const PptPreviewModal = ({
  isOpen,
  onClose,
  title,
  previewUrl,
  downloadUrl,
  editUrl,
}: PptPreviewModalProps) => {
  const iframeUrl = editUrl || previewUrl;
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent height="80%">
        <ModalHeader color="navyBlue.500" fontSize="md" py={3} pl={4}>
          {title}
        </ModalHeader>
        <ModalCloseButton />
        {downloadUrl && (
          <Button
            title="Download file"
            leftIcon={<IconArrowInbox size={16} />}
            as="a"
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download file"
            size="sm"
            variant="ghost"
            colorScheme="navyBlue"
            position="absolute"
            top={2}
            right={12}
          >
            Download
          </Button>
        )}
        <ModalBody padding={0} height="100%">
          {iframeUrl && (
            <Iframe
              id="ds-frame"
              url={iframeUrl}
              width="100%"
              height="100%"
              position="relative"
              styles={{ border: 'none' }}
              allowFullScreen
              allow="storage-access *"
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
